module.exports = __webpack_public_path__ + "img/icon-1.c87853e7.svg";